"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMultiInputFieldSelectedSections = void 0;
var React = _interopRequireWildcard(require("react"));
var _useForkRef = _interopRequireDefault(require("@mui/utils/useForkRef"));
var _useEventCallback = _interopRequireDefault(require("@mui/utils/useEventCallback"));
const useMultiInputFieldSelectedSections = params => {
  const unstableEndFieldRef = React.useRef(null);
  const handleUnstableEndFieldRef = (0, _useForkRef.default)(params.unstableEndFieldRef, unstableEndFieldRef);
  const [startSelectedSection, setStartSelectedSection] = React.useState(params.selectedSections ?? null);
  const [endSelectedSection, setEndSelectedSection] = React.useState(null);
  const getActiveField = () => {
    if (unstableEndFieldRef.current && unstableEndFieldRef.current.isFieldFocused()) {
      return 'end';
    }
    return 'start';
  };
  const handleStartSelectedSectionChange = (0, _useEventCallback.default)(newSelectedSections => {
    setStartSelectedSection(newSelectedSections);
    if (getActiveField() === 'start') {
      params.onSelectedSectionsChange?.(newSelectedSections);
    }
  });
  const handleEndSelectedSectionChange = (0, _useEventCallback.default)(newSelectedSections => {
    setEndSelectedSection(newSelectedSections);
    if (getActiveField() === 'end') {
      params.onSelectedSectionsChange?.(newSelectedSections);
    }
  });
  const activeField = getActiveField();
  return {
    start: {
      unstableFieldRef: params.unstableStartFieldRef,
      selectedSections: activeField === 'start' && params.selectedSections !== undefined ? params.selectedSections : startSelectedSection,
      onSelectedSectionsChange: handleStartSelectedSectionChange
    },
    end: {
      unstableFieldRef: handleUnstableEndFieldRef,
      selectedSections: activeField === 'end' && params.selectedSections !== undefined ? params.selectedSections : endSelectedSection,
      onSelectedSectionsChange: handleEndSelectedSectionChange
    }
  };
};
exports.useMultiInputFieldSelectedSections = useMultiInputFieldSelectedSections;